import { Clock } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, SectionHead } from "@/components/Reveal";
import { ARTICLES } from "@/lib/site";

export default function Articles() {
  return (
    <div data-testid="articles-page" className="pt-[72px]">
      <Seo
        title="Health & Recovery Articles | Kamana Physiotherapy, Lucknow"
        description="Practical, evidence-based recovery advice from Kamana Physiotherapy — desk posture, morning back stiffness, knee care and returning to sport safely."
      />

      <section className="bg-teal-obsidian text-alabaster grain-dark relative overflow-hidden">
        <div className="absolute inset-0 hero-glow" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-24">
          <p className="mono-label text-gold">Health &amp; Recovery Articles</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mt-4 leading-[1.06] max-w-3xl">
            Knowledge is <span className="italic text-gold">preventive medicine.</span>
          </h1>
          <p className="mt-6 text-alabaster/70 max-w-2xl leading-relaxed">
            Short, practical guides written by our clinical team — the same advice we give patients
            in the room, written down for you.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <SectionHead label="Latest Articles" title="Read. Apply. Recover." />
        <div className="grid md:grid-cols-2 gap-5 mt-12">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.07}>
              <article className="h-full bg-white border border-teal-brand/10 rounded-3xl p-8 card-lift">
                <div className="flex items-center gap-3">
                  <span className="mono-label text-gold-deep !text-[9px] bg-gold-soft border border-gold/20 rounded-full px-3.5 py-1.5">
                    {a.tag}
                  </span>
                  <span className="text-xs text-inkmuted flex items-center gap-1.5">
                    <Clock size={12} /> {a.readTime}
                  </span>
                </div>
                <h2 className="font-display text-2xl font-semibold text-teal-brand mt-4 leading-snug">
                  {a.title}
                </h2>
                <p className="text-sm text-inkmuted leading-relaxed mt-3">{a.excerpt}</p>
                <div className="mt-5 space-y-3 border-t border-teal-brand/10 pt-5">
                  {a.body.map((p, j) => (
                    <p key={j} className="text-sm text-inkmuted leading-relaxed">
                      {p}
                    </p>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
